import { pageMetaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import ServiceEcommerceImage from "@/assets/service-ecommerce.jpg";

const PAGE_KEY = "/shopify-websites";

export const Route = createFileRoute("/shopify-websites")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: pageMetaTitle(PAGE_KEY, loaderData.title) },
          { name: "description", content: loaderData.description },
          { property: "og:title", content: pageMetaTitle(PAGE_KEY, loaderData.title) },
          { property: "og:description", content: loaderData.description },
      { property: "og:url", content: "https://www.phil-carr.co.uk/shopify-websites" },
        ]
      : [],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/shopify-websites" }],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <MarkdownPage body={page.body} pageContext={page.title} heroImage={{ src: ServiceEcommerceImage, alt: 'Stack of kraft parcels ready for shipping beside a laptop' }} relatedSlugs={["turning-website-visitors-into-customers-with-seo", "building-a-website-that-supports-seo-and-business-growth", "product-reviews-and-algorithm-updates"]} />
  );
}
